import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type GetCallerTipGourmetVariables = {
  callerId: string;
};

export const getCallerTipGourmet = async ({ callerId }: GetCallerTipGourmetVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
    },
    query: graphql(`
      query GetCallerTipGourmet($callerId: String!) {
        getCallerTipGourmet(callerId: $callerId) {
          type
          percentage
          maximum
          amount
        }
      }
    `),
  });

  return response.data?.getCallerTipGourmet;
};
